import {Component, OnInit, OnDestroy } from '@angular/core';
import * as $ from 'jquery';
import { CentralService} from '../servicios/central.service';
import {faSignInAlt, faKey, faEuroSign, faTractor, faMoneyBill, faFileInvoice, 
        faCheckCircle, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import {Router } from '@angular/router';
import {AvisosComponent} from '../avisos/avisos.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';



@Component({
  selector: 'app-fichacap',
  templateUrl: './fichacap.component.html',
  styleUrls: ['./fichacap.component.css']
})
export class FichacapComponent implements  OnInit {

  icoEntr = faSignInAlt;
  icoKey = faKey;
  icoEur = faEuroSign;
  icoTra = faTractor;
  icoMny = faMoneyBill;
  icoInv = faFileInvoice;
  icoVal  = faCheckCircle;
  icoFac = faFileAlt;
  fecdia: string;
  nomusu: string;
  menu: any;
  iconos = [this.icoKey, this.icoEur, this.icoTra, this.icoMny, this.icoInv, this.icoFac];

  modoLis = 0;
  formLis = 0;
  SwDetal = false;
  SwResum = false;
  SwTotal = false;
  SwExcel = false;
  SwImpre = false;
  SwLista = false;
  resul: boolean;


  constructor(private srvCentral: CentralService, private router: Router, private modalService: NgbModal ) { }

  ngOnInit(): void {

    this.fecdia = Date().toLocaleString();
    this.nomusu = this.srvCentral.datosIden.UsuNom;

    /* Cargo tabla de menús */
    if (this.srvCentral.datosIden.UsuUsu !== '') {
       const k = this.srvCentral.listaMnu.length;
       this.menu = [];
       for ( let i = 0; i < k; i++)  {
           this.menu.push(
             { nombre: this.srvCentral.listaMnu[i].nombre,
               ruta:  this.srvCentral.listaMnu[i].ruta,
               icono: this.iconos[this.srvCentral.listaMnu[i].ico]
           } );

       }
    }
    this.modoLis = this.srvCentral.FicModoLis;
    this.formLis = this.srvCentral.FicFormLis;

    switch (this.modoLis) {
      case 0:
        this.SwResum = true;
        break;
      case 1:
        this.SwDetal = true;
        break;
      case 2:
        this.SwTotal = true;
        break;
    }

    switch(this.formLis) {
      case 0:
         this.SwLista = true;
         break;
      case 1:
         this.SwImpre = true;
         break;
      case 2:
         this.SwExcel = true;
         break;
    }

  }

  persiana(): void {
    $('#wrapper').toggleClass('toggled');
  }

  modos(md: number): void {
    this.modoLis = md;
  }
  formas(fm: number): void {
    this.formLis = fm;
  }
  listado(): void {
    this.srvCentral.FicModoLis = this.modoLis;
    this.srvCentral.FicFormLis = this.formLis;
    if (this.formLis === 0) {
        this.router.navigate(['/fichacaplis']);
    }
    if (this.formLis === 1) {
        this.router.navigate(['/fichacapimp']);
    }
    if (this.formLis === 2) {
        this.listadoExcel();
    }
 }

 listadoExcel(): void {
  this.resul = true;
  this.srvCentral.fichaCapital(this.modoLis, 1)
      .subscribe(datos => {
        if (datos[0].cpFecha === '?') {
          this.resul = false;
          const modalRef = this.modalService.open(AvisosComponent);
          modalRef.componentInstance.datAviso = {tit: 'ERROR SERVIDOR',
                                                 tex: datos[0].cpConce,
                                                 tip: 2,
                                                 btcan: '',
                                                 btno: '',
                                                 btsi: 'Aceptar'};
          modalRef.result.then((result) => {
          });

        } else {
             this.resul = false;
             const tx = this.srvCentral.saca(datos[0].cpConce);
             const url = this.srvCentral.UrlCave + '/' + tx;
             window.open(url, '_blank');
        }
     });
 }

}


